import React, { createContext, useState, useContext } from 'react';

const CompactModeContext = createContext();



export const useCompactMode = () => useContext(CompactModeContext);

export const CompactModeProvider = ({ children }) => {
  const [compactMode, setCompactMode] = useState(false);

  const toggleCompactMode = () => setCompactMode(prev => !prev);

  return (
    <CompactModeContext.Provider value={{ compactMode, setCompactMode, toggleCompactMode }}>
      {children}
    </CompactModeContext.Provider>
  );
};
